(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('MoneyTransferLogSearch', MoneyTransferLogSearch);

    MoneyTransferLogSearch.$inject = ['$resource'];

    function MoneyTransferLogSearch($resource) {
        var resourceUrl = 'api/_search/money-transfer-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
